/**
 * INSTITUTIONAL DEPTH V1 (LOT 1) — Séparateur éditorial.
 * Respiration entre chapitres : filets latéraux + glyphe losange or.
 * Aucune animation lourde — apparition par Reveal du parent si souhaité.
 */
import React from 'react';

export const EditorialDivider = ({ tone = 'light', className = '', testid }) => {
  const dark = tone === 'dark';
  const line = dark ? 'bg-ivory/20' : 'bg-stone';
  const glyph = dark ? 'border-gold/70' : 'border-gold-dark/70';
  return (
    <div className={`flex items-center justify-center gap-5 ${className}`} role="separator" aria-hidden="true" data-testid={testid}>
      <span className={`block h-px w-16 md:w-24 ${line}`} />
      <span className={`block w-2 h-2 rotate-45 border ${glyph}`} />
      <span className={`block h-px w-16 md:w-24 ${line}`} />
    </div>
  );
};

export default EditorialDivider;
